import * as types from "./mutation-type";

export default {
  [types.SET_ITEMS_CART](state, payload) {
    state.itemsCart = payload
  },
  [types.SET_CHECKOUT_KEY](state, payload) {
    state.checkoutKey = payload
  },
  [types.SET_CALLED_GET_ITEMS_CART](state, payload) {
    state.calledGetItemsCart = payload
  },
  [types.SET_DISABLED_VARIATION](state, payload) {
    state.disabledVariation = payload
  },
  [types.SET_LIST_CART_WITH_ADDITIONAL_PRODUCTS](state, payload) {
    state.listCartWithAdditionalProducts = payload
  }
}
